import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

const CreateOrCloneEventLeague = ({ handleNext, setDetails, details }) => {
  const handleClick = (action, e) => {
    e.preventDefault()
    setDetails({ ...details, actionType: action})
    handleNext({ action })
  }

  return (
    <div className='popup_form_content'>
      <h2>{ window.I18n.t('customer_center_menu.components.popups.sim_golf.create_or_clone_event_league_header') }</h2>
      <button onClick={ (e) => handleClick('createEvent', e) }>
        <div>
          <div className='button_header'>
            <img src={require('create_event_league.svg')} />
            <span className='button_title'>{ window.I18n.t('customer_center_menu.components.popups.sim_golf.create_new_event_league_button') }</span>
          </div>
          <span className='button_subtitle'>{ window.I18n.t('customer_center_menu.components.popups.sim_golf.create_new_event_league_button_info') }</span>
        </div>
      </button>
      <button onClick={ (e) => handleClick('cloneEvent', e) }>
        <div>
          <div className='button_header'>
            <img src={require('clone_event_league.svg')} />
            <span className='button_title'>{ window.I18n.t('customer_center_menu.components.popups.sim_golf.clone_event_league_button') }</span>
          </div>
          <span className='button_subtitle'>{ window.I18n.t('customer_center_menu.components.popups.sim_golf.clone_event_league_button_info') }</span>
        </div>
      </button>
    </div>
  )
}

CreateOrCloneEventLeague.propTypes = {
  handleNext: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
  details: PropTypes.object.isRequired,
}

export default CreateOrCloneEventLeague
